module.exports = __webpack_public_path__ + "static/media/banner-clients-03-mobile.d106f613.jpg";